import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      whatYouGetBanner: {
        livejasmin: {
          ...defineMessages({
            whatYouGet: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.whatYouGet',
              defaultMessage: 'What you get as a <b>Model</b>',
            },
            maximize: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.maximize',
              defaultMessage: 'Maximize your earnings while doing what you love!',
            },
            example: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.example',
              defaultMessage: 'Here’s a real example of how much you can make.',
            },
            earnUpTo: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.earnUpTo',
              defaultMessage: 'Earn up to',
            },
            revenueShare: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.revenueShare',
              defaultMessage: 'revenue share',
            },
            extra: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.extra',
              defaultMessage: 'Extra',
            },
            referBonus: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.referBonus',
              defaultMessage: 'bonus for every new member you refer',
            },
            seeExample: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.seeExample',
              defaultMessage: 'See a detailed example',
            },
            numbersVary: {
              id: 'pages.landing.whatYouGetBanner.livejasmin.numbersVary',
              defaultMessage:
                'Numbers may vary depending on currency, package amount, income level and payment method.',
            },
          }),
        },
      },
    },
  },
};
